import DashboardLayout from "examples/LayoutContainers/DashboardLayout"
// Vision UI Dashboard React components
import VuiBox from "components/VuiBox";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import { useEffect, useState } from "react";
import { CreditUsers, Transaction, UserData } from "Api";
import { Button, Table, message, Modal } from "antd";
import { getAuth } from "firebase/auth";
import { ConfirmDeposit, ConfirmWithdraw, GetPendingTransactions, GetUsers } from "utils/AdminUtil";
import VuiTypography from "components/VuiTypography";
import UserDetailsPage from "./userDetails";

export default function Admin (){
    const [pendingTrans, setPendingTrans] = useState([])
    const [penLoading, setPenLoading] = useState(false)
    const [users, setUsers] = useState([])
    const [userLoading, setUserLoading] = useState(false)
    const [selected, setSelected] = useState(UserData.emtpy())
    const [show, setShow] = useState(false)
    const [loading, setLoading] = useState(false)

    useEffect(() => {
        const auth = getAuth();
       const sub = auth.onAuthStateChanged((user) => {
       })
       FetchData()
       FetchDataUsers();
       return () =>{
        sub()
       }
      }, []);

      async function FetchData(){
        setPenLoading(true)
        const res = await GetPendingTransactions();
        setPendingTrans(res);
        setPenLoading(false)
      }

      async function FetchDataUsers(){
        setUserLoading(true)
        const res = await GetUsers();
        setUsers(res);
        setUserLoading(false)
      }
    const columns = [
        {
          title: 'Amount',
          dataIndex: 'amount',
          key: 'amount',
          render: (text) => `$${text.toFixed(2)}`, // Render amount with a dollar sign
        },
        {
          title: 'Date',
          dataIndex: 'date',
          key: 'date',
          render: (text) => text.toLocaleDateString(), // Render date in a readable format
        },
        {
          title: 'Type',
          dataIndex: 'type',
          key: 'type',
        },
        {
          title: 'Address',
          dataIndex: 'address',
          key: 'address',
        },
        {
          title: 'Coin',
          dataIndex: 'coin',
          key: 'coin',
        },
        {
            title: 'Actions',
            key: 'actions',
            render: (text, record) => (
              <Button type="primary" onClick={() => handleConfirm(record)}>
                Confirm
              </Button>
            ),
          },
      ];

      const handleConfirm = async (record) => {
        setPenLoading(true)
        switch (record.type) {
            case "deposit":
                await ConfirmDeposit(record);
                break;
            case "withdrawal":
                await ConfirmWithdraw(record);
            default:
                break;
        }
        setPenLoading(false)
        FetchData()
        message.success("Transaction confirmed")
      };
    
      const columns2 = [
        {
          title: 'Name',
          dataIndex: 'name',
          key: 'name',
        },
        {
          title: 'Balance',
          dataIndex: 'balance',
          key: 'balance',
          render: (text) => `$${text.toFixed(2)}`, // Render balance with a dollar sign
        },
        {
          title: 'Actions',
          key: 'actions',
          render: (text, record) => (
            <Button type="primary" onClick={() => handleAction(record)}>
              View
            </Button>
          ),
        },
      ];
    
      const handleAction = (record) => {
        setSelected(record)
        setShow(true)
      };
    
    const creditPlans = async() => {
      setLoading(true)
      try {
        await CreditUsers()
        message.success("Users credited")
      } catch (error) {
        console.log(error)
        message.error("Error crediting users")
      }
      setLoading(false)
    }
    return(
    <DashboardLayout>
        <DashboardNavbar />
        <VuiBox className="min-vh-100">
        <div className="mb-5">
          <Button onClick={creditPlans} disabled={loading}> Credit Due Plans</Button>
          </div>
            <div className="mb-5">
            <VuiTypography variant="lg" color="white">
                Pending Transactions
              </VuiTypography>
            <Table loading={penLoading} columns={columns} dataSource={pendingTrans}/>
            </div>
            <div>
            <VuiTypography variant="lg" color="white">
                Users
              </VuiTypography>
            <Table loading={userLoading} columns={columns2} dataSource={users}/>
            </div>
            <Modal
            title="User Details"
            open={show}
            onOk={() => setShow(false)}
            onCancel={() => setShow(false)}
            width={600}
            footer={null}
            >
                <UserDetailsPage userData={selected} refreshUsers={FetchDataUsers} close={() => setShow(false)}/>
            </Modal>
        </VuiBox>
        </DashboardLayout>
        )
}